module.exports = __webpack_public_path__ + "static/media/logo-white.15b4d295.png";